import { addValidationRule } from '@a2software/formsy-react'

addValidationRule('isNotEmpty', function (formValues, value) {
  return !!value && !!value.trim()
})
